<script setup lang="ts">
import { paths } from '~/lib/paths'
import type { SectionFeaturedLocationListRecord } from '~/types/datocms'
import { ModelApiKey } from '~/types/models'

const { locale } = useI18n()
const localeRoute = useLocalePath()

defineProps<{
  data: SectionFeaturedLocationListRecord
}>()
</script>

<template>
  <div v-if="data" class="bg-black py-4 text-yellow lg:pb-8 lg:pt-10">
    <div v-if="data.title" class="container mb-4 text-sm uppercase text-cream lg:mb-8">
      {{ data.title }}
    </div>
    <div
      v-if="data.category || data.country"
      class="container mb-2 text-lg uppercase lg:mb-6 lg:text-xl"
    >
      <NuxtLink
        v-if="data.category"
        class="group inline-flex"
        :to="
          localeRoute({
            path: `/${paths[locale][ModelApiKey.Location].path}`,
            query: { category: data.category?.slug }
          })
        "
      >
        {{ data.category?.name }}
        <span
          class="ml-1 inline-flex h-4 w-4 items-center justify-center rounded-full bg-yellow/20 transition-colors group-hover:bg-yellow"
        >
          <Icon
            name="custom:arrow-right"
            class="shrink-0 text-yellow transition-colors group-hover:text-black"
            size="12"
          />
        </span>
      </NuxtLink>
      <NuxtLink
        v-if="data.country"
        :to="
          localeRoute({
            path: `/${paths[locale][ModelApiKey.Location].path}`,
            query: { country: data.country?.slug }
          })
        "
        class="group ml-6 inline-flex lg:ml-8"
      >
        {{ data.country?.name }}
        <span
          class="ml-1 inline-flex h-4 w-4 items-center justify-center rounded-full bg-yellow/20 transition-colors group-hover:bg-yellow"
        >
          <Icon
            name="custom:arrow-right"
            class="shrink-0 text-yellow transition-colors group-hover:text-black"
            size="12"
          />
        </span>
      </NuxtLink>
    </div>
    <LazySwiperFeaturedLocations
      v-if="data.imageGallery?.length"
      :data="data.imageGallery"
      :location="data.location"
      :country="data.country"
      :category="data.category"
    />
  </div>
</template>
